import { Center } from '@mantine/core';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import Footer from '../Footer';
import Header from '../Header';
import PageBody from '../PageBody';
import useIntl from '@/infrastructure/hooks/useIntl';

export function CustomRootErrorBoundary() {
  const t = useIntl('common');
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div>
      <Header />
      <PageBody>
        <Center mx='xl'>
          {t('errors.globalCriticalError')}
        </Center>
      </PageBody>
      <Footer />
    </div>
  );
}
